export default "__VITE_ASSET__C1eA2dFL__"